
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"14","height":"8"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"kwwwa","d":"M1701.049 1032.086c.464.458.954.889 1.37 1.393.185.224.36.455.492.714.189.37.018.777-.31.799h-2.04c-.526.043-.945-.171-1.298-.535-.283-.29-.544-.599-.816-.898a1.913 1.913 0 00-.367-.33c-.278-.183-.52-.127-.679.166-.162.299-.2.63-.215.961-.022.486-.167.613-.65.636-1.03.048-2.008-.11-2.917-.634-.802-.463-1.423-1.117-1.964-1.856-1.053-1.442-1.86-3.025-2.584-4.653-.163-.366-.044-.563.356-.57a56.185 56.185 0 011.997 0c.27.004.45.16.554.418.36.894.8 1.744 1.353 2.532.147.21.298.42.512.568.236.163.416.11.527-.157.072-.17.102-.35.118-.532a8.013 8.013 0 00-.033-1.86c-.057-.388-.272-.638-.655-.711-.194-.037-.166-.11-.071-.222.164-.195.318-.315.626-.315h2.304c.363.072.444.236.494.606l.002 2.585c-.005.143.07.567.325.66.203.068.338-.097.46-.227.552-.592.946-1.29 1.298-2.014.156-.319.29-.65.42-.98.097-.244.248-.365.521-.36l2.219.002c.065 0 .132 0 .196.012.374.065.477.227.36.595-.181.58-.535 1.061-.88 1.544-.371.518-.767 1.017-1.133 1.537-.338.475-.311.714.108 1.126z"}})]),_c('use',{attrs:{"fill":"#ffdb4d","xlink:href":"#kwwwa","transform":"translate(-1689 -1027)"}})])
          )
        }
      }
    